<section class="screen-saver">
    <div class="screen-saver--header">
        <img src="assets/images/screen-saver-logo.svg"
             class="logo best-fit"
             alt="SalesRun Logo">
    </div>
    <div class="screen-saver--content">
        <div class="screen-saver--content--error">
            <span class="screen-saver--content--error--code"></span>
            <span class="screen-saver--content--error--message"></span>
        </div>
        <div class="screen-saver--content--message">
            Single sign-on login failed<br/>
            Ensure your credentials are correct
        </div>
        <a mat-stroked-button
                    href="/login">
                    BACK TO LOGIN PAGE
        </a>
        <div class="flex-padding"></div>
    </div>
    <div class="screen-saver--footer">
        <span class="copyright">
            SalesRun v5.0 - All Rights Reserved
        </span>
    </div>
</section>